import { create } from "zustand";
import { persist } from "zustand/middleware";

type State = {
	session_uuid: string;
	setSessionUuid: (session_uuid: string) => void;
};
export const useSessionStore = create(
	persist<State>(
		(set, get) => ({
			session_uuid: "",
			setSessionUuid: (session_uuid) => {
				set({ session_uuid });
			},
		}),
		{
			name: "session-store",
		},
	),
);
